import React, {useState} from 'react'

export default function TextForm(props) {
    const handleUpClick = () =>{
        // console.log("Uppcase Was Clicked");
        let newText = text.toUpperCase();
        setText(newText);
    }
    
    const handleLowClick = () =>{
        // console.log("Uppcase Was Clicked");
        let newText = text.toLowerCase();
        setText(newText);
    }
    const handleOnChange = (event) =>{
        // console.log("On Chane");
        setText(event.target.value);
    }
    const handleclearClick = (event) =>{
        let newText = '';
        setText(newText);
    }
    const handlecopyText = (event) =>{
        var text = document.getElementById("myBox");
        text.select();
        navigator.clipboard.writeText(text.value);
       
    //     if(text.value.length>0){
    //         alert ("Text is copied");
    //     }
    //    else{
    //     alert ("Please enter the text");
    //    }
        
    }
    
    const handleExtraSpaces = (event) =>{
        let newText = text.split(/[ ]+/);
        setText(newText.join(" "));
    }
    const [text, setText] = useState('');
    const wordCount = text.trim().split(/\s+/).length;
  return (
    <>
    <div className='container' style={{color:props.mode === 'dark'?'white':'#042743'}}>
        <div className="mb-3">
            <h1>{props.heading}</h1>
            <textarea className="form-control" value={text} style={{backgroundColor:props.mode === 'light'?'white':'#042743', color:props.mode === 'dark'?'white':'#042743'}} onChange = {handleOnChange} id="myBox" rows="8"></textarea>
        </div>
        <div>
           <button disabled={text.length===0} className="btn btn-primary mx-2 my-2" onClick= {handleUpClick}>Convert to Uppercase</button>
           <button disabled={text.length===0} className="btn btn-primary mx-2 my-2" onClick= {handleLowClick}>Convert to Lowercase</button>
           <button disabled={text.length===0} className="btn btn-primary mx-2 my-2" onClick= {handleclearClick}>Clear</button>
           <button disabled={text.length===0} className="btn btn-primary mx-2 my-2" id="myBox" onClick= {handlecopyText}>Copy Text</button>
           <button disabled={text.length===0} className="btn btn-primary mx-2 my-2" onClick= {handleExtraSpaces}>Remove Space</button>
        </div>
       
    </div>
    <div className="container my-3" style={{color:props.mode === 'dark'?'white':'#042743'}}>
        <h2>Your text summary</h2>
        <p>{text.length > 0 ? `${wordCount} words and  ${text.length} characters`: "0 words and 0 characters"}</p>
        <p>{text.length>0 ? ` ${0.008 * text.length} Minute to read the article` : "0 Minute to read" }</p>
        <h2>Preview</h2>
        <p>{text.length>0 ? text : "Nothing to preview"}</p>
    </div>
    </>
  )
}